import { api } from '../../lib/api';
import type { CacheInvalidateResult, CronsResponse, ServicesResponse } from './types';

export function fetchServices(): Promise<ServicesResponse> {
  return api.get<ServicesResponse>('/admin/services');
}

export function restartService(id: string, stepUpToken: string): Promise<void> {
  return api.post(`/admin/services/${id}/restart`, undefined, { stepUpToken });
}

export function fetchCrons(): Promise<CronsResponse> {
  return api.get<CronsResponse>('/admin/crons');
}

export function invalidateCache(
  pattern: string,
  stepUpToken: string,
): Promise<CacheInvalidateResult> {
  return api.post<CacheInvalidateResult>(
    '/admin/cache/invalidate',
    { pattern },
    { stepUpToken },
  );
}
